import { useEffect, useRef } from 'react';

export const useBodyNoScroll = (scroll: boolean) => {
  const bodyRef = useRef<HTMLBodyElement>();
  useEffect(() => {
    bodyRef.current = document.querySelector('body') as HTMLBodyElement;
    if (scroll) {
      bodyRef.current.classList.add('no-scroll');
    } else {
      if (bodyRef.current.classList.contains('no-scroll')) {
        bodyRef.current.classList.remove('no-scroll');
      }
    }
    return () => bodyRef.current?.classList?.remove('no-scroll');
  }, [scroll, bodyRef.current]);
};
